<template>
  <el-dialog title="删除" class="messageDelete" :visible.sync="dialogFormVisible" top="20%" width="460px">
    <div class="content">
      <i class="el-icon-warning"></i>
      <span class="text">是否确认删除此条信息，是否继续？</span>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-checkbox v-model="checked">下次删除操作不再提示</el-checkbox>
      <div>
        <el-button @click="submitForm('cancel')">取 消</el-button>
        <el-button type="primary" @click="submitForm('true')">确认</el-button>        
      </div>
    </div>
  </el-dialog>
</template>
<script>
  // import * as api from 'src/api'
  // import { Message } from 'element-ui'
  export default {
    data () {
      return {
        dialogFormVisible: false,
        checked: false
      }
    },
    methods: {
      submitForm (type) {
        this.$emit('submitDelete', this.checked, type)
        this.dialogFormVisible = false
      }
    }
  }
</script>
<style lang="less">
  .messageDelete .el-dialog__header {
    background: #ffffff;
    .el-dialog__title {
      font-size: 16px;
      font-weight: bold;
      color: #1f2d3d;
    }
    .el-dialog__headerbtn {
      display: none;
    }
  }
  .messageDelete .content{
    display: flex;
    align-items: center;
    .el-icon-warning {
      font-size: 40px;
      color: #f7ba2a;
    }
    .text {
      margin-left: 15px;
      font-size:14px;
      color:#475669;
      font-weight: bold;
    }
  }
  .messageDelete {
    .el-dialog__footer {
      background: #ffffff;
      .dialog-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }      
    }
  }
</style>


// WEBPACK FOOTER //
// delete-message.vue?dcc8fd88